import { Navigate, useLocation } from 'react-router-dom';
import { clearSession, decodeToken, getAccessToken, getRole, isTokenExpired } from '../utils/auth';

// Gate for every route that requires an admin-panel login. Pass `allowedRoles`
// to additionally restrict a route to specific roles.
const ProtectedRoute = ({ element, allowedRoles }) => {
  const location = useLocation();
  const accessToken = getAccessToken();
  const session = decodeToken(accessToken);
  const userRole = getRole();
  const hasRefreshToken = Boolean(localStorage.getItem('refreshToken'));

  if (!accessToken || !userRole) {
    // Logged out or tampered token. Drop whatever is left behind so a stale
    // `role`/`emailId` can't be read by anything downstream.
    clearSession();
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (isTokenExpired(session) && !hasRefreshToken) {
    // Expired access token with no refresh path available. Force a hard logout
    // to prevent a stale session from remaining in storage.
    clearSession();
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles) {
    const normalizedAllowed = allowedRoles.flat().map((r) => String(r).toLowerCase().trim());
    if (!normalizedAllowed.includes(userRole.toLowerCase())) {
      return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
    }
  }

  return element;
};

export default ProtectedRoute;
